import React, {useState, useEffect} from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import {useTranslation} from 'react-i18next';
import SMCModal from '../../components/core/SMCModal';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../components/Simple/SMCButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import config from '../../conf/config';

function VerifyCaptchaModal({
    isOpen,
    onRequestClose,
    onFinish
}) {
    const { t } = useTranslation();

    const [captchaKey, setCaptchaKey] = useState(null);

    const handleFinish = () => {
        if (!captchaKey) {
            alert('Please verify CAPTCHA');
        } else {
            onFinish(captchaKey);
        }
    };

    // Reset values on each new open
    useEffect(() => {
        if (isOpen) {
            setCaptchaKey(null);
        }
    }, [isOpen]);
    
    return (
        <SMCModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            height={250}
            width={360}
            title="Verify CAPTCHA"
        >
            <SMCModalBody>
                <ReCAPTCHA
                    sitekey={config.google_captcha_key}
                    onChange={setCaptchaKey}
                />
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={handleFinish}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_OK')}
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>
    );
}

export default VerifyCaptchaModal;